import request from '@/utils/request'

export function getList(query) {
  return request({
    url: '/AssetInfos/Load',
    method: 'get',
    params: query,
  })
}

export function add(data) {
  return request({
    url: '/assetInfos/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/assetInfos/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/assetInfos/delete',
    method: 'post',
    data
  })
}

export function saveBatchUpdate(data) {
  return request({
    url: '/assetInfos/saveBatchUpdate',
    method: 'post',
    data
  })
}

export function getChangeRecords(query) {
  return request({
    url: '/AssetInfos/GetChangeRecords',
    method: 'get',
    params: query,
  })
}

export function getAccessoryList(assetCode) {
  return request({
    url: '/AssetAccessorys/GetByAssetCode',
    method: 'get',
    params: { assetCode }
  })
}